import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';

function RtlAwareToast() {
  const [isRtl, setIsRtl] = useState(localStorage.getItem('cartz_dash_lang') === 'ar' || localStorage.getItem('cartz_lang') === 'ar');

  useEffect(() => {
    const check = () => {
      setIsRtl(localStorage.getItem('cartz_dash_lang') === 'ar' || localStorage.getItem('cartz_lang') === 'ar');
    };
    // Listen for storage events + poll for same-tab changes
    window.addEventListener('storage', check);
    const interval = setInterval(check, 500);
    return () => { window.removeEventListener('storage', check); clearInterval(interval); };
  }, []);

  return (
    <ToastContainer
      position={isRtl ? 'bottom-left' : 'bottom-right'}
      rtl={isRtl}
      autoClose={1500}
    />
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <RtlAwareToast />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
